import React, { createContext, useState } from "react";

const MotivoCancelamentoContext = createContext();
const MotivoCancelamentoProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [released, setReleased] = useState(true);
  const [errorsSubmit, setErrorsSubmit] = useState({});
  const [companies, setCompanies] = useState([]);
  const [dataTableReload, setDataTableReload] = useState(false);
  const [id, setId] = useState(null);

  return (
    <MotivoCancelamentoContext.Provider
      value={{
        loading,
        setLoading,
        description,
        setDescription,
        released,
        setReleased,
        errorsSubmit,
        setErrorsSubmit,
        companies,
        setCompanies,
        dataTableReload,
        setDataTableReload,
        id,
        setId,
      }}
    >
      {children}
    </MotivoCancelamentoContext.Provider>
  );
};

export { MotivoCancelamentoProvider, MotivoCancelamentoContext };
